import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TratativaEnderecoService {

  changeQtdeInconEnd = new EventEmitter();
  public qtdeInconsistenciasEnderecos: number = 0;

  constructor(private readonly http: HttpClient) { }

  getInconsistencias(idImportacao: any){
    const url: string = `/apiconnect/file-summary/imports/${idImportacao}/to-from/address-errors`;

    return this.http.get(url);
  }

  postDepara(bodyEndereco: FormData, idImportacao:any) {
    const url: string = `/apiconnect/file-summary/imports/${idImportacao}/to-from/address-errors`;
    return this.http.post(url, bodyEndereco);
  }

  verficiaStatusDepara(idImportacao: any, cep: string) {
    const url: string = `/apiconnect/core/importation/${idImportacao}/adress/${cep}/zip`;

    return this.http.get(url);
  }

  getEnderecosCadastrados(idImportacao: any) {
    const url: string = `/apiconnect/orders/import/from-to/address/${idImportacao}/companies`;

    return this.http.get(url);
  }

}
